function subcategoryAsideInit() {
	const opener = document.querySelector("[data-category-menu='opener']");
	const closer = document.querySelector("[data-category-menu='closer']");
	const target = document.querySelector("[data-category-menu='target']");
	const activeClass = "category-menu-is-toggled";
	if (opener) {
		opener.addEventListener("click", function() {
			document.body.classList.add(activeClass);
			this.setAttribute("aria-expanded", "true");
			target.setAttribute("aria-hidden", "false");
		});
	}
	if (closer) {
		closer.addEventListener("click", function() {
			document.body.classList.remove(activeClass);
			this.setAttribute("aria-expanded", "false");
			target.setAttribute("aria-hidden", "true");
		});
	}
	return;
}
